export enum CallDirectionState {
  Inbound = "Inbound",
  Outbound = "Outbound",
  Missed = "Missed"
}
